import '../static/Input.css';
import React__default, { memo, forwardRef, useState, useCallback } from "react";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { b as FieldBox } from "./FieldBox.CBa86mdz.mjs";
import { S as SvgClose1Px } from "./close-1px.BL6ZlEPp.mjs";
const input = `_input_ff23529`;
const suffix = `_suffix_68592cf`;
const styles = { input, suffix };
const ClearButton = memo(
  // eslint-disable-next-line react/prop-types
  ({ allowClear, ariaControls, clearLabel, onClick }) => {
    if (!allowClear) {
      return null;
    }
    return /* @__PURE__ */ React__default.createElement(
      "button",
      {
        type: "button",
        tabIndex: -1,
        onMouseDown: (e) => {
          e.preventDefault();
        },
        onClick,
        "aria-controls": ariaControls,
        "aria-label": clearLabel,
        className: styles.suffix
      },
      /* @__PURE__ */ React__default.createElement(SvgClose1Px, { "aria-hidden": "true" })
    );
  }
);
const InputInner = forwardRef(
  ({
    className,
    id = "input",
    label,
    labelId,
    labelVisible,
    onChange = () => {
    },
    onClear = () => {
    },
    required,
    requiredLabel,
    disabled,
    asPlaceholder = false,
    errorMessage,
    helperMessage,
    successMessage,
    allowClear,
    clearLabel = "Clear input value",
    suffix: suffix2,
    theme,
    ...props
  }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      FieldBox,
      {
        className,
        id,
        asPlaceholder,
        label,
        labelId,
        labelVisible,
        required,
        requiredLabel,
        disabled,
        helperMessage,
        errorMessage,
        successMessage,
        value: props.value,
        theme,
        suffix: allowClear ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
          ClearButton,
          {
            allowClear,
            clearLabel,
            onClick: onClear,
            ariaControls: id
          }
        ), suffix2) : suffix2,
        ...props
      },
      /* @__PURE__ */ React__default.createElement(
        Paragraph,
        {
          ...props,
          as: "input",
          ref,
          onChange: (e) => onChange(e.target.value),
          className: styles.input
        }
      )
    );
  }
);
const Input = forwardRef(
  ({ defaultValue, onChange, ...props }, ref) => {
    const [inputValue, setInputValue] = useState(defaultValue || "");
    const handleInputChange = useCallback(
      (value) => {
        setInputValue(value);
        onChange && onChange(value);
      },
      [onChange]
    );
    return /* @__PURE__ */ React__default.createElement(
      InputInner,
      {
        ref,
        value: inputValue,
        onChange: handleInputChange,
        onClear: () => handleInputChange(""),
        ...props
      }
    );
  }
);
const InputControlled = forwardRef((props, ref) => {
  return /* @__PURE__ */ React__default.createElement(InputInner, { ref, ...props });
});
export {
  Input as I,
  InputControlled as a
};
//# sourceMappingURL=Input.CXxqKRC9.mjs.map
